import React from "react";
import "./Billing_manegment_card.css";
import { Table } from "react-bootstrap";
import Orange_btn from "../../../../../common_components/common_btn/orange_btn/Orange_btn";
import Blue_btn from "../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import downloadAnimation from "../../../../../animation/success_lottie/Download_lottie.json";

function Billing_manegment_card({
  invoiceId,
  program,
  amount,
  issuedDate,
  dueDate,
  status,
  paymentMethod,
  isPaid,
}) {
  const [modalDownloadShow, setModalDownloadShow] = React.useState(false);
  return (
    <>
      <section className="Billing_manegment_card card_box">
        <div className="custom_table table_scroll">
          <Table borderless responsive>
            <thead>
              <tr>
                <th>Invoice ID</th>
                <th className="right_text">{invoiceId}</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Program</td>
                <td className="right_text">{program}</td>
              </tr>

              <tr>
                <td>Amount</td>
                <td className="right_text">{amount}</td>
              </tr>

              <tr>
                <td>Date Issued</td>
                <td className="right_text">{issuedDate}</td>
              </tr>

              <tr>
                <td>Due Date</td>
                <td className="right_text">{dueDate}</td>
              </tr>

              <tr>
                <td>Status</td>
                <td className="right_text">
                  <span
                    className={`status-badge ${
                      status === "Pending" ? "under-review" : "accepted"
                    }`}
                  >
                    {status}
                  </span>
                </td>
              </tr>

              <tr>
                <td>Payment Method</td>
                <td className="right_text">{paymentMethod}</td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="btn_holder">
          {isPaid ? (
            <Blue_btn
              btn_text="Download Invoice"
              onClick={() => setModalDownloadShow(true)}
            />
          ) : (
            <Orange_btn btn_text="Pay Now" />
          )}
        </div>
      </section>
      <Success_modal
        show={modalDownloadShow}
        onHide={() => setModalDownloadShow(false)}
        message_text={"Downloading Invoice"}
        animationData={downloadAnimation}
      />
    </>
  );
}

export default Billing_manegment_card;
